/*
 * @Author: liuqing
 * @Date: 2021-01-21 16:59:33
 * @LastEditors: renmanyi
 * @LastEditTime: 2022-09-09 12:01:48
 * @Description: 人脸考勤系统
 * @Copyright: © 2020 杭州杰竞科技有限公司 版权所有
 */
import React, { useEffect, useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { Radio, Button, message, Modal } from 'antd';
import _ from 'underscore';
import AttendPage from './AttendPage';
import ClickOutside from '../components/ClickOutside';
import Setting from './Setting';
import Bus from '../../core/bus';
import User from '../../core/user';
import AxiosTS from '../../core/axios';
import StudentInfoPage from './StudentInfoPage';
import RedOrangeTheme from './RedOrangeTheme';
import BlackTheme from './BlackTheme';
import { getParameterByName } from '../../core/function';
import { convertBase64ToBlob, random_string, getEnvValue } from '../../core/function';
import Upload from '../../core/upload';
import './theme/FaceBase.less';
import LayerPaperPage from './LayerPaperPage';

const studentId = getParameterByName('studentId');
let timer = null;
function FaceSystem(props) {
  const [type, setType] = useState(!studentId ? 'attend' : 'info');
  const [openInstDropdown, setOpenInstDropdown] = useState(false);
  const [student, setStudent] = useState(!!studentId);
  const [instScroll, setInstScroll] = useState(false);
  const [instAdminId, setInstAdminId] = useState(window.userAdminInfo.adminId);
  const [networkSpeed, setNetworkSpeed] = useState(0); // 当前网速
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'black');
  const radioGroupNode = useRef(null);
  const layPaper = useRef(null);
  const [currentInst, setCurrentInst] = useState({
    bizAccountId: '',
    instId: '',
    version: ''
  });
  const [checkFlag, setCheckFlag] = useState(false); // 检测原因功能的标志

  Bus.bind('faceColor', theme => {
    setTheme(theme);
  });
  useEffect(() => {
    let bgColor = '';
    switch (theme) {
      case 'white':
        bgColor = '#F4F4F4';
        break;
      case 'orange':
        bgColor = 'linear-gradient(90deg, #FFB76C 0%, #FF8651 100%)';
        break;
      case 'blue':
        bgColor = 'linear-gradient(135deg, #41A3E7 0%, #3A62CF 100%)';
        break;
      case 'red_orange':
        bgColor = 'linear-gradient(315deg, #FF9A59 0%, #F35E5E 100%)';
        break;
      case 'black':
        bgColor = 'linear-gradient(360deg, #313642 0%, #272831 100%)';
        break;
      default:
        break;
    }
    document.getElementById('app').style.background = bgColor;
  }, [theme]);
  useEffect(() => {
    getSpeedWithAjax();
    timer = setInterval(() => {
      getSpeedWithAjax();
    }, 15000);
    return () => {
      clearTimeout(timer);
      if (radioGroupNode && radioGroupNode.current) {
        radioGroupNode.current.removeEventListener('scroll', scrollEventListener);
      }
    };
  }, []);

  function pageShow() {
    layPaper.current.pageShow();
  }

  /**
   * 获取实时的网速
   */
  function getSpeedWithAjax() {
    if (navigator.onLine) {
      return new Promise((resolve, reject) => {
        let start = null;
        let end = null;
        start = new Date().getTime();
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            end = new Date().getTime();
            // const size = xhr.getResponseHeader('content-length') / 1024;
            let speed = (12.88671875 * 1000) / (end - start);
            speed = (speed / 1000).toFixed(1);
            if (speed === 'Infinity') {
              speed = 0;
            }
            resolve(speed);
            setNetworkSpeed(speed);
          }
        };
        xhr.open('GET', 'https://image.xiaomaiketang.com/xm/kxjjxisEts.webp?' + new Date().getTime());
        xhr.send();
      }).catch(err => {
        throw err;
      });
    } else {
      setNetworkSpeed(0);
    }
  }
  // 动态添加阴影
  function addShadow() {
    radioGroupNode.current = document.getElementById('inst-radio-group');
    radioGroupNode.current.addEventListener('scroll', scrollEventListener);
    setTimeout(() => {
      if (radioGroupNode.current.scrollHeight > radioGroupNode.current.clientHeight) {
        setInstScroll(true);
      }
    }, 0);
  }
  function scrollEventListener() {
    if (radioGroupNode.current.scrollHeight === radioGroupNode.current.scrollTop + 258) {
      setInstScroll(false);
    } else {
      setInstScroll(true);
    }
  }
  // 点击切换校区的时候判断有没有人脸考勤权限，需要每一次都调用权限接口
  // 然后比对当前用户有没有这个权限 ~_~
  function handleClickInst(item) {
    setCurrentInst({
      instId: item.instId,
      bizAccountId: item.adminId,
      version: item.saaSVersionEnum
    });
  }
  // 判断是否有人脸权限
  function checkPermission() {
    return AxiosTS.Business('public/common/queryCommonPermissionByVersion', currentInst).then(res => {
      // 是否有人脸权限
      const permissionListCode = _.chain(res.result).get('userPermissionGroupList').pluck('groupCode');
      const hasPermissionV4 = permissionListCode.contains('1118').value();
      const hasPermissionV5 = permissionListCode.contains('FaceAttendance').value();
      return hasPermissionV4 || hasPermissionV5;
    });
  }
  // 切换校区
  function handleChangeInst() {
    const query = {
      adminType: 'INST_ADMIN',
      defaultAdminId: instAdminId,
      userId: User.uid()
    };
    checkPermission().then(hasPermission => {
      if (hasPermission) {
        AxiosTS.Business('public/b/changeUserDefaultAdmin', query).then(res => {
          const href = window.location.href;
          const urls = href.split('?');
          window.location = urls[0];
          window.location.reload();
        });
      } else {
        Modal.info({
          title: '当前校区未开通人脸考勤',
          content: '请先开通人脸考勤功能',
          okText: '我知道了',
          icon: <span className='icon iconfont default-confirm-icon'>&#xe6f1;</span>,
          onOk: () => {
            setInstAdminId(window.currentUserInstInfo.adminId);
          }
        });
      }
    });
  }
  /**
   * 复制链接
   */
  function copyText() {
    const input = document.getElementById('copy-input');
    input.value = `https://${getEnvValue()}.xiaomai5.com/faceDetection/${process.env.DEPLOY_ENV === 'gray' ? 'gray/' : ''}index.html#home`;
    input.select(); // 选中文本
    document.execCommand('copy'); // 执行浏览器复制命令
    message.success('复制成功！');
  }
  // 切换校区弹窗
  function instMenu() {
    if ((window.userAdminVOList || []).length > 0) {
      return (
        <div className={`select-inst ${openInstDropdown ? 'active' : ''}`}>
          <div className='select-title'>切换校区</div>
          <Radio.Group id='inst-radio-group' value={instAdminId} onChange={e => setInstAdminId(e.target.value)}>
            {_.map(window.userAdminVOList || [], item => (
              <Radio className='inst-item' key={item.instId} value={item.adminId} onClick={() => handleClickInst(item)}>
                <span style={{ width: '100%', whiteSpace: 'normal' }}>{item.instName}</span>
              </Radio>
            ))}
          </Radio.Group>
          {instScroll && <div className='scroll-shadow' />}
          <div className='control'>
            <Button
              size='small'
              onClick={() => {
                setOpenInstDropdown(false);
              }}>
              取消
            </Button>
            <Button
              size='small'
              type='primary'
              onClick={() => {
                handleChangeInst();
              }}>
              确定
            </Button>
          </div>
        </div>
      );
    }
    return null;
  }
  // 顶部校区
  function renderInst() {
    if ((window.userAdminVOList || []).length > 0) {
      return (
        <ClickOutside
          onClickOutside={() => {
            if (openInstDropdown) {
              setOpenInstDropdown(false);
            }
          }}
          className='inst-container'>
          <React.Fragment>
            <div
              className='inst'
              onClick={() => {
                setOpenInstDropdown(!openInstDropdown);
                addShadow();
              }}>
              <span className='inst-name'>{window.userAdminInfo.instName}</span>
              <span className='icon iconfont select'>&#xe6bb;</span>
            </div>
            {instMenu()}
          </React.Fragment>
        </ClickOutside>
      );
    }
  }
  /**
   * 点击【检测原因】按钮
   */
  function testReasonBtnClick() {
    const video_canvas = document.getElementById('video_canvas');
    const dataUrl = video_canvas.toDataURL('image/jpeg');
    const Blob = convertBase64ToBlob(dataUrl);
    const resourceName = new Date().getTime()+'.jpeg';
    const params = {
      blob:Blob,
      name: resourceName,
      type:'image/jpeg',
      dataType: 'id',
      bizCode:'UPLOAD_SEARCH_STUDENT_FACE'
    };
    Upload.newUploadBlobToOSS(params).then((res) => {
      AxiosTS.Business('public/attendance/checkFace', {
        instId: window.userAdminInfo.instId,
        resourceId: res.resourceId
      }).then(() => {
        message.success('检测无异常，请耐心等待系统识别结果');
      });
    });
  }
  return (
    <div className={`${theme} face-system-page`}>
      {theme === 'red_orange' && <RedOrangeTheme />}
      {theme === 'black' && <BlackTheme />}
      <div className='header'>
        <h1 className='title'>小麦助教·智能人脸考勤系统</h1>
        <div className='right'>
          {renderInst()}
          <div
            className='exist'
            onClick={() => {
              const params = {
                appTerm: 'PC',
                userType: 'B',
                xmToken: localStorage.getItem('token')
              };
              AxiosTS.Business('public/b/logout', params);
              localStorage.removeItem('token');
              props.history.push('/login');
            }}>
            退出登录
            <span style={{ marginLeft: 4, marginTop: 3 }} className='icon iconfont'>
              &#xe7e4;
            </span>
          </div>
        </div>
      </div>
      <div className='body__main'>
        <div className='top'>
          <div className='top__left'>
            <div
              className={`top__tab ${type === 'attend' ? 'active' : ''}`}
              onClick={() => {
                setType('attend');
                setStudent(false);
              }}>
              <span>人脸考勤签到</span>
            </div>
            <div
              className={`top__tab ${type === 'info' ? 'active' : ''}`}
              onClick={() => {
                setType('info');
                setCheckFlag(false);
              }}>
              <span>人脸信息采集</span>
            </div>
          </div>
          <div></div>
          <div className='top__right'>
            {checkFlag && type === 'attend' && (
              <span className='test-reason'>
                人脸无法识别？点击这里
                <span onClick={_.debounce(testReasonBtnClick, 3000, true)}>
                  检测原因
                  <i className='icon iconfont' style={{ position: 'relative', top: 2 }}>
                    &#xe6fa;
                  </i>
                </span>
              </span>
            )}
            当前网速：{networkSpeed}Mbps
          </div>
        </div>
        <div className='top__line'></div>
        <div className='main'>
          {type === 'attend' && (
            <AttendPage
              theme={theme}
              checkFlagChange={value => {
                setCheckFlag(value);
              }}
            />
          )}
          {type === 'info' && <StudentInfoPage studentId={!!student && studentId} />}
        </div>
        <div className='tips'>
          <strong>注意事项：</strong>
          <p>
            1. 使用电脑进行人脸考勤时：请使用谷歌/火狐浏览器，否则不能进行人脸考勤
            <a target='_blank' href='http://www.chromeliulanqi.com/'>
              下载谷歌浏览器&gt;
              <span className='recommend'>推荐</span>
            </a>
            <a target='_blank' href='https://www.firefox.com.cn/'>
              下载火狐浏览器&gt;{' '}
            </a>
          </p>
          <p>
            2. 使用平板进行人脸考勤时：苹果请使用Safari浏览器、安卓请使用火狐浏览器。推荐使用分辨率为1024 *
            768的平板。复制链接后在平板上打开即可进行考勤。链接：
            {`https://${getEnvValue()}.xiaomai5.com/faceDetection/${process.env.DEPLOY_ENV === 'gray' ? 'gray/' : ''}index.html#home`}
            <img
              style={{ cursor: 'pointer', margin: '-2px 4px 0' }}
              width={19}
              height={20}
              src='https://image.xiaomaiketang.com/xm/W7w8b2rQZw.png'
              onClick={copyText}
              alt='复制链接icon'
            />
          </p>
          <p>3. 使用前请检查摄像设备是否已经正确连接</p>
          <p>4. 学员需先完成人脸信息采集，否则不能进行人脸考勤</p>
          <p>5. 九岁以下小孩，建议每三个月更新一次照片</p>
          <p>6. 部分电脑自带的浏览器驱动无法兼容，请根据电脑型号下载驱动</p>
          <p>
            7. 人脸采集告知书内容可点击
            <span className='paper_notice' onClick={pageShow}>
              《人脸采集告知书》
            </span>
            进行查看
          </p>
        </div>
      </div>
      <Setting />
      <textarea style={{ position: 'absolute', left: '-10000px' }} id='copy-input' />
      <LayerPaperPage ref={layPaper} />
      <style jsx>
        {`
          .paper_notice {
            color: #ff7519;
            cursor: pointer;
          }
        `}
      </style>
    </div>
  );
}
export default withRouter(FaceSystem);
